import ModernHomepage from "./ModernHomepage"
import TopicCategories from "./TopicCategories"
import LatestZones from "./LatestZones"
import TrendingZones from "./TrendingZones"
import Footer from "./Footer"

export default ModernHomepage
export {
  TopicCategories,
  LatestZones,
  TrendingZones,
  Footer
}